import { useQuery } from '@tanstack/react-query'
import { ExtendableQueryOptions } from 'shared/api/api.types'

import { appointlyApi } from '../..'
import { AppointlyMainLink, GetMainLinksResponse } from './getMainLinks.types'

export const getMainLinks = async (
  userIds: number[]
): Promise<AppointlyMainLink[]> => {
  const params = new URLSearchParams()

  userIds.forEach(userId => {
    params.append('user_ids[]', String(userId))
  })

  const response = await appointlyApi.get<GetMainLinksResponse>(
    `/api/event-types/main-links?${params.toString()}`
  )

  const payload = response.data.data

  return Array.isArray(payload) ? payload : (payload?.data ?? [])
}

export const GET_MAIN_APPOINTLY_LINKS_QUERY_KEY = 'getMainAppointlyLinks'

export const useGetMainAppointlyLinksQuery = (
  userIds: number[],
  options?: ExtendableQueryOptions<AppointlyMainLink[]>
) =>
  useQuery({
    queryKey: [GET_MAIN_APPOINTLY_LINKS_QUERY_KEY, userIds],
    queryFn: () => getMainLinks(userIds),
    ...options
  })
